import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Container, Stack, Step, StepLabel, Stepper } from '@mui/material';
import { Box } from '@mui/system';
import { pdfjs } from 'react-pdf';
import { useLocation } from 'react-router-dom';

// import pages
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import '../styles/alicestyle.css';
import AddJourney1 from './JourneySteps/AddJourney1';
import AddJourney2 from './JourneySteps/AddJourney2';
import AddJourney3 from './JourneySteps/AddJourney3';
import AddJourney4 from './JourneySteps/AddJourney4';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getAllJourneyConfigData } from '../../store/Slice/Journey/JourneySlice';
import useJourneySelector from '../../store/Slice/Journey/JourneySelector';
// import gstin from './dummy/gstin.pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function AddJourney() {
  const [activeStep, setActiveStep] = React.useState(0);

  const dispatch = useDispatch();
  const location = useLocation();
  const { rowData, pageType } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const { JourneyEdit } = useJourneySelector();

  useEffect(() => {
    if (pageType === 'Edit') {
      getAllJourneyConfigApi();
    }
  }, []);

  const handleNext = () => {
    if (rowData?.journeyId !== null && rowData?.journeyId !== undefined) {
      getAllJourneyConfigApi();
    }
    setActiveStep((activeStep) => activeStep + 1);
  };

  const handlePrev = () => {
    setActiveStep((activeStep) => activeStep - 1);
    if (rowData?.journeyId !== null && rowData?.journeyId !== undefined) {
      getAllJourneyConfigApi();
    }
  };

  useEffect(() => {
    localStorage.setItem('journeybyIdData', JSON.stringify(JourneyEdit));
  }, [JourneyEdit]);

  const getAllJourneyConfigApi = useCallback(() => {
    if (!rowData && !LoginData) return '';
    const obj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      journeyId: rowData?.journeyId
    };
    dispatch(getAllJourneyConfigData(obj));
  }, [LoginData, rowData]);

  return (
    <Page title="Partner Managemet System || Journey">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Add New Journey" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Stepper
            connector=""
            activeStep={activeStep}
            sx={{ marginBottom: '25px' }}
            className="stepWizardOuter"
          >
            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Journey Details</StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Design Flow</StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Review</StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Preview &#38; Submit</StepLabel>
            </Step>

            {/* <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Select Other Page</StepLabel>
            </Step> */}
          </Stepper>
          {activeStep === 0 ? (
            <AddJourney1 handleNext={handleNext} />
          ) : activeStep === 1 ? (
            <AddJourney2 handleNext={handleNext} handlePrev={handlePrev} />
          ) : activeStep === 2 ? (
            <AddJourney3 handleNext={handleNext} handlePrev={handlePrev} />
          ) : (
            <AddJourney4 handlePrev={handlePrev} />
          )}
        </Box>
      </Container>
    </Page>
  );
}

export default AddJourney;
